// extracted by mini-css-extract-plugin
export default {"container":"aZ-z","list":"bZ-z"};